export default class extends Controller {
  static targets= ['replyForm', 'reply']

  toggleReplies(){
    event.preventDefault()
    if (this.replyTarget.children.length > 0) {
      this.replyTarget.classList.toggle('d-none')
    } else {
      this.replyTarget.classList.toggle('d-none')
      fetch(event.currentTarget.href, {
        headers: {
          Accept: "text/vnd.turbo-stream.html",
        },
      })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
    }
  }

  showReplyForm(){
    this.replyFormTarget.classList.toggle('d-none')
  }
}
